import { nest } from "d3";
import { locations } from "../util";
import { GEO_IDS_MAP } from "../api/topojson";
/** Getters */
export const getTimeValue = (d) => new Date(d.date);
export const getFacetLabel = (metadata) => (d) => {
    const f = metadata.facets.find(f => f.id === d.facetId);
    return f ? f.label : `[NO FACET LABEL] ${d.facetId}`;
};
export const getLabel = (d) => d.label;
export const getLocation = (d) => d.location;
export const getValue = (d) => d.value;
export const getObservationsWithLabel = (facets, observations) => {
    observations.map((o) => {
        facets.map((f) => {
            if (o.facetId === f.id) {
                o.label = f.label;
            }
        });
    });
    return observations;
};
export const getAvailableLocations = metadata => {
    const raumDimension = metadata.dimensions.find(d => {
        return d.id === "RAUM";
    });
    if (!raumDimension || raumDimension.type !== "geo") {
        throw Error(`No location value found in this dataset`);
    }
    else {
        return raumDimension.domain;
    }
};
export const getLocationLabel = (metadata) => (locationId) => {
    const locations = getAvailableLocations(metadata);
    const f = locations.find(l => l.id === locationId);
    return f ? f.label : `[NO LOCATION LABEL] ${locationId}`;
};
export const getAvailableEntities = metadata => {
    const availableLocations = getAvailableLocations(metadata);
    const locationsByEntities = availableLocations.map((loc) => ({
        locationID: loc.id,
        locationName: loc.label,
        geoEntityID: locations.filter((d) => loc.id === d.locationID ? loc.id === d.locationID : d.locationID = "R30000")[0]
            .geoEntityID,
        geoEntityName: locations.filter((d) => loc.id === d.locationID ? loc.id === d.locationID : d.locationID = "R30000")[0]
            .geoEntityName
    }));
    const availableEntities = Array.from(new Set(locationsByEntities.map((loc) => loc.geoEntityName)));
    return availableEntities;
};
export const getMappableEntities = (metadata) => {
    const mappableEntities = [];
    getAvailableEntities(metadata).map(d => {
        if (d === "Kreise" || d === "Quartiere")
            mappableEntities.push(d);
    });
    return mappableEntities;
};
export const locationsByEntities = nest()
    .key(d => d.geoEntityName)
    .object(locations);
export const getLocationsFromEntity = (entity) => {
    const locations = locationsByEntities[entity].map((d) => d.locationID);
    return locations;
};
export const filterByGeoEntity = (data, locations) => {
    const filteredData = data.filter(d => locations.includes(d.location));
    if (!filteredData) {
        throw Error(`Filter by geo entity failed!`);
    }
    return filteredData;
};
export const getAvailableViews = metadata => {
    const hasLocations = getAvailableEntities(metadata).some(loc => loc === "Kreise" || loc === "Quartiere" || loc === "Historische Kreise");
    if (hasLocations) {
        return ["Grafik", "Tabelle", "Karte"];
    }
    else {
        return ["Grafik", "Tabelle"];
    }
};
const excludedDimensions = ['RAUM', 'ZEIT', 'GLOSSAR', 'QUELLEN', 'FUSSNOTE', 'KORREKTUR', 'METHODE'];
export const getDimensions = (metadata) => {
    const dimensions = metadata.dimensions.filter((d) => !excludedDimensions.includes(d.id));
    return dimensions;
};
export const getFacetsFromDimension = (metadata, dimension) => {
    const facets = dimension &&
        metadata.dimensions.filter(dim => dim.id === dimension)[0].domain;
    return facets;
};
export const getAvailableDates = (data) => {
    const availableDates = Array.from(new Set(data.map(d => new Date(d.date).getTime())));
    return availableDates;
};
export const getGeoID = (d) => {
    const geoID = GEO_IDS_MAP.get(d.location);
    if (!geoID) {
        throw Error(`No GeoID found for ${d.location}`);
    }
    return geoID;
};
export const getGeoEntityFeaturesName = (entity) => {
    switch (entity) {
        case "Kreise":
            return "stadtkreise";
        case "Quartiere":
            return "statistische_quartiere";
        default:
            return "stadtkreise";
    }
};
export const getGeoEntityLakeBorderFeaturesName = (entity) => {
    switch (entity) {
        case "Kreise":
            return "stadtkreis_lakebounds";
        case "Quartiere":
            return "statistische_quartiere_lakebounds";
        default:
            return "stadtkreis_lakebounds";
    }
};



// WEBPACK FOOTER //
// ./src/detail/getters.ts